import React, { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import "../CourseList.scss";
import "./studentList.scss";
import moment from "moment/moment";
import { DateRange } from "react-date-range";
import Pagination from "../MemberList/Pagination";
import { CourseBuilderStaticData } from "../../../../_constants/staticData";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import editIcon from "../../../../assets/icons/icon-edit.png";
import deleteIcon from "../../../../assets/icons/icon-delete.png";
import Forms from "../MemberList/Forms";
import BulkUploadOverlay from "../../Shared/BulkUpload/BulkUploadOverlay";
import { downloadCSV } from "../../../../_helpers";
import AddMenu from "../AddMenu/AddMenu";
import Modal from "../../../Other/Modal"; // Import the Modal component
import { FaEdit, FaEye, FaSort, FaTrash } from "react-icons/fa";
import { User, Award, Calendar, BookOpen, UserCheck, CheckCircle2, XCircle, Trophy } from "lucide-react";

function StudentsList() {

  const [studentData, setStudentData] = useState([]);
  const [studentStats, setStudentStats] = useState([]);
  const [viewData, setViewData] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [studentId, setStudentId] = useState(0);
  const [dateRangePicker, setDateRangePicker] = useState(false);
  const [modal, setModal] = useState(false); // Modal state for editing student
  const [dateToggle, setDateToggle] = useState(false);
  const [editStudentData, setEditStudentData] = useState([]);
  const [addMenu, setAddMenu] = useState(false);
  const [addBulkUsers, setAddBulkUsers] = useState(false); // Modal state for bulk upload
  const [isUploaded, setIsUploaded] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [activeTab, setActiveTab] = useState("info");
  const [studentQuizzes, setStudentQuizzes] = useState([]);
  const [quizzesLoading, setQuizzesLoading] = useState(false);

  const [filter, setFilter] = useState({
    status: "",
    startDate: "",
    endDate: "",
    page: 1,
    itemsPerPage: 10,
  });

  const [apiPages, setApiPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const refOne = useRef(null);
  const [editRow, setEditRow] = useState(null);

  const staticData = [
    {
      name: "Total Students",
      total: studentStats?.totalStudents || "0",
      boxShadow: "Dashboard-color-one",
      color: "color-one",
    },
    {
      name: "Active Students",
      total: studentStats?.activeStudents || "0",
      boxShadow: "Dashboard-color-two",
      color: "color-two",
    },
    {
      name: "Paid Students",
      total: studentStats?.paidStudents || "0",
      boxShadow: "Dashboard-color-three",
      color: "color-three",
    },
    {
      name: "Just Join",
      total: studentStats?.justJoined || "0",
      boxShadow: "Dashboard-color-four",
      color: "color-four",
    },
  ];

  const fetch = async () => {
    //console.log("Fetching with filter:", filter);
    const { status, page, itemsPerPage, startDate, endDate } = filter;

    setLoading(true);
    try {
      const res = await axiosInstance.get(
        `user/student?status=${status}&page=${page}&perPage=${itemsPerPage}&startDate=${startDate}&endDate=${endDate}`
      );
      setStudentData(res.data?.data?.data);
      setApiPages(res.data.data.total_page);
    } catch (error) {
      console.error("Error fetching student data:", error.message);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const fetchStudentStats = async () => {
      try {
        const res = await axiosInstance.get("admin/student-statistics");
        setStudentStats(res?.data?.data);
      } catch (error) {
        console.error("Error fetching student statistics:", error.message);
      }
    };

    fetchStudentStats();
  }, [isUploaded]);


  useEffect(() => {
    fetch();
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
  }, [filter, modal, confirmDelete, isUploaded]);

  useEffect(() => {
    if (viewData && activeTab === "quizzes") {
      const fetchStudentQuizzes = async () => {
        setQuizzesLoading(true);
        try {
          const res = await axiosInstance.get(`/test/list?studentId=${viewData.id}&perPage=100`);
          setStudentQuizzes(res?.data?.data?.data || []);
        } catch (error) {
          console.error("Error fetching student quizzes:", error);
        } finally {
          setQuizzesLoading(false);
        }
      };
      fetchStudentQuizzes();
    }
  }, [viewData, activeTab]);

  const handleSelectChange = (e) => {
    setFilter({ ...filter, itemsPerPage: e.target.value });
  };

  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const hideOnEscape = (e) => {
    if (e.key === "Escape") {
      setDateToggle(false);
    }
  };

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setDateToggle(false);
    }
  };

  const handleDateRangeFilter = (item) => {
    setFilter({
      ...filter,
      startDate: moment(item.selection.startDate).format("YYYY-MM-D"),
      endDate: moment(item.selection.endDate).format("YYYY-MM-D"),
    });
    setRange([item.selection]);
  };


  const deleteStudent = (userId) => {
    setConfirmDelete(true);
    setStudentId(userId);
  };

  const handleDeleteStudent = async () => {
    try {
      const res = await axiosInstance.post("admin/user/delete/", {
        userId: studentId,
      });

      if (res) {
        setConfirmDelete(false);
      }
    } catch (error) {
      console.error("Error deleting student:", error.message);
      setConfirmDelete(false); // Still close the modal even if it fails
    }
  };


  const handleAddStudent = () => {
    setModal(true); // Open the modal for adding a new student
    setEditStudentData([]); // Clear any existing data
    setAddMenu(false);
  };

  const handleEditStudent = (data) => {

    setModal(true); // Open the modal for editing a student
    setEditStudentData(data); // Pass the student data to the modal
  };

  const handleStatusFilter = (e) => {
    setFilter({ ...filter, status: e.target.value });
  };

  const handleStudentList = async () => {
    try {
      const res = await axiosInstance.get("/admin/export/students");
      downloadCSV(res?.data, "Student-list");
    } catch (error) {
      console.error("Error downloading student list:", error.message);
      // Optionally: show a toast or alert to the user
    }
  };


  const handleAddBulkUsers = (type) => {
    setAddBulkUsers(true); // Open the modal for bulk upload
    setAddMenu(false);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  const handleViewStudent = (data) => {
    setViewData(data);
    setActiveTab("info");
    setStudentQuizzes([]);
  };
  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return studentData;
    const sorted = [...studentData].sort((a, b) => {
      let aValue, bValue;
      switch (sortConfig.key) {
        case "srno":
          aValue = a.id;
          bValue = b.id;
          break;
        case "name":
          aValue = `${a.firstName} ${a.lastName}`.toLowerCase();
          bValue = `${b.firstName} ${b.lastName}`.toLowerCase();
          break;
        case "studentId":
          aValue = a.id;
          bValue = b.id;
          break;
        case "userName":
          aValue = a.userName?.toLowerCase() || "";
          bValue = b.userName?.toLowerCase() || "";
          break;
        case "email":
          aValue = a.email?.toLowerCase() || "";
          bValue = b.email?.toLowerCase() || "";
          break;
        case "phoneNumber":
          aValue = a.phoneNumber || "";
          bValue = b.phoneNumber || "";
          break;
        case "createdAt":
          aValue = a.createdAt || "";
          bValue = b.createdAt || "";
          break;
        case "status":
          aValue = a.status ? 1 : 0;
          bValue = b.status ? 1 : 0;
          break;
        default:
          aValue = a[sortConfig.key];
          bValue = b[sortConfig.key];
      }
      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "asc"
          ? aValue - bValue
          : bValue - aValue;
      }
      return 0;
    });
    return sorted;
  }, [studentData, sortConfig]);
  const handleLastMonth = () => {
    const now = new Date();
    const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const endOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);

    setFilter({
      ...filter,
      startDate: moment(startOfLastMonth).format("YYYY-MM-D"),
      endDate: moment(endOfLastMonth).format("YYYY-MM-D"),
    });
  };

  const handleStatusChange = async (userId, currentStatus, role) => {
    //console.log("currentStatus", currentStatus, userId);

    const url = currentStatus === 0
      ? "/user/v1/deactive"
      : "/user/v1/reactivate";

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      let response;

      if (currentStatus === 1) {
        response = await axiosInstance.post(
          url,
          { userId, role },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        response = await axiosInstance.put(
          url,
          { userId, role },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      const result = response.data;
      fetch();
      if (!result.error) {
        alert(result.message || "Status updated successfully");
      } else {
        alert(result.message || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
      alert("Error changing status");
    }
  };




  return (
    <div className="width-0 student-list-container m-0 p-0">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="dashboard-container-new">
            <p>Student List</p>
            <div>
              <button className="lastmonth-btn" onClick={handleLastMonth}>
                Last Month
              </button>
              <button className="export-btn" onClick={handleStudentList}>
                Export
              </button>
            </div>
          </div>
          <div className="flex-dashboard-new-1">
            {staticData && staticData?.map((item, index) => (
              <div className={`box-shadow-06 ${item.boxShadow}`} key={index}>
                <p className="font-custom-p">{item.name}</p>
                <p className={`font-increase ${item.color}`}>{item.total}</p>
              </div>
            ))}
          </div>
          <div className="page-data-new">
            <div>
              {studentData && studentData?.length > 0 ? (
                <p className="showing-result">
                  Showing {filter.page} page of {filter.itemsPerPage} results
                </p>
              ) : (
                <p className="showing-result">Showing 0 result</p>
              )}
            </div>
            <div className="pagination-flex">
              <div className="pagination-add">
                {" "}
                <button onClick={() => setAddMenu((state) => !state)}>
                  <span>&#10009;</span>
                </button>
                {addMenu && (
                  <AddMenu
                    setAddMenu={setAddMenu}
                    handleAddBulkUsers={handleAddBulkUsers}
                    handleAddUser={handleAddStudent}
                    role="Student"
                  />
                )}
              </div>
              <div className="pagination-date">
                {dateRangePicker === false ? (
                  <>
                    <input
                      type="text"
                      placeholder="Date Range"
                      className="date-ranger-student"
                      onClick={() => {
                        setDateRangePicker(true);
                        setDateToggle(true);
                      }}
                    />
                  </>
                ) : (
                  <input
                    type="text"
                    value={`${moment(range[0].startDate).format(
                      "MM/DD/YYYY"
                    )} to ${moment(range[0].endDate).format("MM/DD/YYYY")}`}
                    placeholder="Date Range"
                    className="date-ranger-student-updated"
                    onClick={() => setDateToggle(true)}
                  />
                )}
                <div className="dateWrap" ref={refOne}>
                  {dateToggle && (
                    <DateRange
                      onChange={(item) => handleDateRangeFilter(item)}
                      editableDateInputs={true}
                      moveRangeOnFirstSelection={false}
                      ranges={range}
                      months={1}
                      direction="horizontal"
                      className="dateElement"
                    />
                  )}
                </div>
              </div>
              <div>
                <div className="pagination-select">
                  <select
                    className="select-dropdown-instructor-2"
                    onChange={handleStatusFilter}
                  >
                    <option value="">Select Status</option>
                    <option value="0">Pending</option>
                    <option value="1">Completed</option>
                  </select>
                </div>
              </div>

              <div>
                <p className="item-page-result">Item per page</p>
              </div>
              <div className="pagination-select">
                <select
                  className="select-dropdown-instructor-1"
                  onChange={(e) => handleSelectChange(e)}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                  <option value={50}>50</option>
                </select>
              </div>
              <div>
                <button
                  className="clear-btn"
                  onClick={() => {
                    setFilter({
                      ...filter,
                      status: "",
                      startDate: "",
                      endDate: "",
                      page: 1,
                    });
                    setRange([{
                      startDate: new Date(),
                      endDate: new Date(),
                      key: "selection",
                    }]);
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
          <div className="instructor-table">
            {studentData?.length === 0 ? (
              <h2 className="no-data-found">No data found</h2>
            ) : (
              <table className="table-width-100">
                <thead>
                  <tr className="cursor-pointer">
                    <th onClick={() => handleSort("srno")}>
                      <div className="flex items-center gap-1">
                        Sr.no{" "}
                        {sortConfig.key === "srno"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("name")}>
                      <div className="flex items-center gap-1">
                        Name{" "}
                        {sortConfig.key === "name"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("userName")}>
                      <div className="flex items-center gap-1">
                        User Name{" "}
                        {sortConfig.key === "userName"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("email")}>
                      <div className="flex items-center gap-1">
                        Email{" "}
                        {sortConfig.key === "email"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("phoneNumber")}>
                      <div className="flex items-center gap-1">
                        Phone Number{" "}
                        {sortConfig.key === "phoneNumber"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("createdAt")}>
                      <div className="flex items-center gap-1">
                        Register Date{" "}
                        {sortConfig.key === "createdAt"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th onClick={() => handleSort("status")}>
                      <div className="flex items-center gap-1">
                        Status{" "}
                        {sortConfig.key === "status"
                          ? sortConfig.direction === "asc"
                            ? "▲"
                            : "▼"
                          : <FaSort className="text-gray-400" />}
                      </div>
                    </th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData?.length > 0 ? (
                    sortedData?.map((ele, index) => {
                      return (
                        <>
                          <tr key={index} >
                            <td className="cell">
                              {filter?.itemsPerPage * filter?.page -
                                filter?.itemsPerPage +
                                index +
                                1}
                            </td>
                            <td className="cell">
                              <div>
                                {ele?.profileImage ? (
                                  <img alt="Profile" src={ele?.profileImage} className="avatar-profile-image-02" />
                                ) : (
                                  ele && <span className="avatar-placeholder">{ele?.firstName.charAt(0)}</span>
                                )}
                                <p>{ele.firstName + " " + ele.lastName}</p>
                              </div>
                            </td>

                            <td className="cell">{ele.userName}</td>
                            <td className="cell">{ele.email}</td>
                            <td className="cell">{ele.phoneNumber || "-"}</td>
                            <td className="cell">
                              {ele.createdAt
                                ? moment(ele?.createdAt).format("DD/MM/YYYY")
                                : "01/12/22"}
                            </td>

                            <td className="cell">
                              {editRow === index ? (
                                <select
                                  value={ele.status}
                                  onChange={(e) => {
                                    handleStatusChange(ele.id, Number(e.target.value), ele.role);
                                    setEditRow(null);
                                  }}
                                  onBlur={() => setEditRow(null)}
                                  className="status-select"
                                >
                                  <option value={1}>Active</option>
                                  <option value={0}>Inactive</option>
                                </select>
                              ) : (
                                <span
                                  onClick={() => setEditRow(index)}
                                  className={`status-badge ${ele.status ? "completed" : "pending"}`}
                                >
                                  {ele.status ? "Completed" : "Pending"}
                                </span>
                              )}
                            </td>
                            <td className="cell flex items-center gap-2 !mt-[14px]">
                              <FaEye
                                className="action-icon"
                                title="View"
                                onClick={() => handleViewStudent(ele)}
                              />
                              <FaEdit
                                className="action-icon"
                                title="Edit"
                                onClick={() => handleEditStudent(ele)}
                              />
                              <FaTrash
                                className="action-icon"
                                title="Delete"
                                onClick={() => deleteStudent(ele.userIds)}
                              />
                            </td>
                          </tr>
                        </>
                      );
                    })
                  ) : (
                    <h2 className="no-data-found">No data found</h2>
                  )}
                </tbody>
              </table>
            )}
            {confirmDelete === true && (
              <Modal
                isOpen={confirmDelete}
                onClose={() => setConfirmDelete(false)}
              >
                <div className="alert-dialog-inner">
                  <div className="alert-title">Warning!</div>
                  <div className="alert-message">
                    {CourseBuilderStaticData.deleteStudentOverlay.header}
                  </div>

                  <div className="alert-close-btn">
                    <a className="btn-save" onClick={handleDeleteStudent}>
                      OK
                    </a>

                    <a
                      className="btn-cancel"
                      onClick={() => setConfirmDelete(false)}
                    >
                      CANCEL
                    </a>
                  </div>
                </div>
              </Modal>
            )}
          </div>
          {/* Pagination */}
          <div className="pageNumbers-sudents">
            {studentData?.length >= 0 ? (
              <Pagination
                className="pageNumbers-sudents"
                currentPage={filter.page}
                totalCount={filter.itemsPerPage}
                pageSize={apiPages}
                onPageChange={(page) => setFilter({ ...filter, page: page })}
              />
            ) : (
              ""
            )}
          </div>
          {viewData && (
            <Modal isOpen={!!viewData} onClose={() => setViewData(null)}>
              <div className="w-full p-6">
                {/* Title */}
                <div className="dashboard-container-new !mb-5 !text-gray-800 !font-bold !text-[18px]">
                  Student Details
                </div>
                <div className="!text-black">
                  {/* Profile Section */}
                  <div className="flex items-center gap-6 mb-6">
                    {viewData.profileImage ? (
                      <img
                        src={viewData.profileImage}
                        alt="Profile"
                        className="w-20 h-20 rounded-full object-cover ring-4 ring-blue-500/30 shadow-md"
                      />
                    ) : (
                      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-2xl font-bold shadow-md">
                        {viewData.firstName?.charAt(0)}
                      </div>
                    )}
                    <div>
                      <h2 className="text-xl font-bold text-gray-800">
                        {viewData.firstName} {viewData.lastName}
                      </h2>
                      <p className="text-gray-500 text-sm">@{viewData.userName}</p>
                    </div>
                  </div>

                  {/* Tab Navigation */}
                  <div className="flex border-b border-gray-200 mb-6 gap-6">
                    <button
                      className={`pb-2.5 text-sm font-bold flex items-center gap-2 border-b-2 transition-all ${
                        activeTab === "info"
                          ? "border-blue-600 text-blue-600"
                          : "border-transparent text-gray-400 hover:text-gray-600"
                      }`}
                      onClick={() => setActiveTab("info")}
                    >
                      <User size={16} /> Personal Info
                    </button>
                    <button
                      className={`pb-2.5 text-sm font-bold flex items-center gap-2 border-b-2 transition-all ${
                        activeTab === "quizzes"
                          ? "border-blue-600 text-blue-600"
                          : "border-transparent text-gray-400 hover:text-gray-600"
                      }`}
                      onClick={() => setActiveTab("quizzes")}
                    >
                      <Award size={16} /> Quiz History
                    </button>
                  </div>

                  {/* Personal Info Tab Content */}
                  {activeTab === "info" && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 bg-gray-50/50 p-5 rounded-2xl border border-gray-100">
                      <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                        <p className="text-[10px] text-gray-400 font-extrabold uppercase tracking-widest mb-1">Email</p>
                        <p className="text-sm font-bold text-gray-700 break-all">{viewData.email}</p>
                      </div>
                      <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                        <p className="text-[10px] text-gray-400 font-extrabold uppercase tracking-widest mb-1">Phone</p>
                        <p className="text-sm font-bold text-gray-700">{viewData.phoneNumber || "—"}</p>
                      </div>
                      <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                        <p className="text-[10px] text-gray-400 font-extrabold uppercase tracking-widest mb-1">Country</p>
                        <p className="text-sm font-bold text-gray-700">{viewData.userCountryCode || "—"}</p>
                      </div>
                      <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                        <p className="text-[10px] text-gray-400 font-extrabold uppercase tracking-widest mb-1">Registered On</p>
                        <p className="text-sm font-bold text-gray-700">
                          {viewData.createdAt
                            ? moment(viewData.createdAt).format("MMMM DD, YYYY")
                            : ""}
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Quiz History Tab Content */}
                  {activeTab === "quizzes" && (
                    <div className="w-full">
                      {quizzesLoading ? (
                        <div className="space-y-3">
                          {[1, 2, 3].map((n) => (
                            <div key={n} className="bg-gray-50 border border-gray-100 rounded-xl p-4 animate-pulse flex items-center justify-between">
                              <div className="space-y-2 w-2/3">
                                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                                <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                              </div>
                              <div className="h-8 bg-gray-200 rounded w-20"></div>
                            </div>
                          ))}
                        </div>
                      ) : studentQuizzes.length === 0 ? (
                        <div className="flex flex-col items-center justify-center p-8 text-center bg-gray-50 rounded-2xl border border-gray-100">
                          <Trophy size={40} className="text-gray-300 mb-3" />
                          <h4 className="text-sm font-bold text-gray-700 mb-1">No Quizzes Attended</h4>
                          <p className="text-xs text-gray-400 max-w-xs leading-relaxed">
                            This student has not completed any assessments or quizzes yet.
                          </p>
                        </div>
                      ) : (
                        <div className="max-h-[350px] overflow-y-auto pr-1 space-y-3">
                          {studentQuizzes.map((ele, idx) => {
                            const totalQ = ele.rightAns + ele.wrongAns;
                            const pct = totalQ > 0 ? Math.round((ele.rightAns / totalQ) * 100) : 0;
                            const passed = pct >= 70;

                            return (
                              <div
                                key={idx}
                                className="bg-white rounded-xl border border-gray-150 p-4 hover:shadow-md transition-all relative overflow-hidden flex flex-col sm:flex-row sm:items-center justify-between gap-4"
                              >
                                <div className={`absolute left-0 top-0 w-1.5 h-full ${passed ? "bg-emerald-500" : "bg-rose-500"}`}></div>

                                <div className="pl-3 flex-1 space-y-1.5">
                                  <div className="flex items-center gap-2 flex-wrap">
                                    <span className="font-bold text-gray-800 text-sm">{ele.name || "Untitled Quiz"}</span>
                                    <span className="bg-blue-50 border border-blue-100 text-blue-700 text-[10px] font-bold px-2 py-0.5 rounded flex items-center gap-1">
                                      <BookOpen size={10} /> {ele.CourseName || "General Quiz"}
                                    </span>
                                  </div>

                                  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-gray-500 font-medium">
                                    <span className="flex items-center gap-1">
                                      <Calendar size={11} className="text-gray-400" />
                                      {ele.createdOn ? moment(ele.createdOn).format("MMM DD, YYYY") : "—"}
                                    </span>
                                    {ele.InstructorName && (
                                      <span className="flex items-center gap-1">
                                        <UserCheck size={11} className="text-gray-400" />
                                        Instructor: <span className="font-bold text-gray-600">{ele.InstructorName}</span>
                                      </span>
                                    )}
                                  </div>
                                </div>

                                <div className="flex items-center gap-4 border-t sm:border-t-0 pt-3 sm:pt-0 border-gray-50 pl-3 sm:pl-0 justify-between sm:justify-end">
                                  <div className="text-right">
                                    <div className="flex items-center gap-1.5 justify-end">
                                      <span className={`text-lg font-extrabold ${passed ? "text-emerald-600" : "text-rose-600"}`}>
                                        {pct}%
                                      </span>
                                      <span className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">Score</span>
                                    </div>
                                    <div className="text-[11px] text-gray-400 font-semibold mt-0.5">
                                      {ele.rightAns} Correct / {totalQ} Total
                                    </div>
                                  </div>

                                  <div>
                                    {passed ? (
                                      <span className="bg-emerald-50 border border-emerald-200 text-emerald-700 text-[10px] font-bold px-2 py-1 rounded flex items-center gap-1">
                                        <CheckCircle2 size={11} className="text-emerald-600" /> PASS
                                      </span>
                                    ) : (
                                      <span className="bg-rose-50 border border-rose-200 text-rose-700 text-[10px] font-bold px-2 py-1 rounded flex items-center gap-1">
                                        <XCircle size={11} className="text-rose-600" /> FAIL
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Modal>
          )}
          {modal && (
            <Modal isOpen={modal} onClose={() => setModal(false)}>
              <Forms
                setModal={setModal}
                title="Student"
                role="Student"
                editData={editStudentData}
              />
            </Modal>
          )}
          {/* Modal for bulk upload */}
          {addBulkUsers && (
            <Modal isOpen={addBulkUsers} onClose={() => setAddBulkUsers(false)}>
              <BulkUploadOverlay
                onCancel={() => setAddBulkUsers(false)}
                role="Student"
                setIsUploaded={setIsUploaded}
              />
            </Modal>
          )}
        </>
      )}
    </div>
  );
}

export default StudentsList;
